import createReducer from 'utils/redux/createReducer'

const initialState = {
  showAll: true,
  forRent: false,
  outOfService: false,
  occupied: false,
  retired: false
}

export default createReducer(initialState, {
    PROPERTY_FILTER_UPDATED: (currentState, action) => ({...currentState, applied: action.data})
  , SWITCH_PROPERTY_OMNI: (currentState, action) => ({...currentState, openedOmniBox: !currentState.openedOmniBox})
  , SWITCH_PROPERTY_DROPDOWN: (currentState, action) => ({...currentState, openedDropDown: !currentState.openedDropDown})
  , HIDE_DROP_DOWN_PROPERTY: (currentState, action) => ({...currentState, openedDropDown: false})
  , CHANGE_PREDEFINED_NAME: (currentState, action) => ({...currentState, predefinedFilterName: action.data})
  ,	CLEAR_PROPERTY_FILTERS: () => initialState
})



// WEBPACK FOOTER //
// ./src/reducers/propertyFilters.js